import React, { Component } from 'react';
import { UserService } from '../../services/user';
import './element-audiobook.css';
import { BookProvider } from './context/book/book-context';
import { AudioProvider } from './components/audiobook/audio/context/audio-context';
import { Audiobook } from './components/audiobook';
import { ChapterList } from './components/chapters/chapter-list/chapter-list';
import { PreferencesProvider } from './context/preferences/preferences-context';
import { UserProvider } from './context/user/user-context';
import { StyledThemeProvider } from './theme';
import { GlobalStyles } from './theme/global';
import { Mode } from './components/mode/mode';

export default class ElementAudioBook extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(content) {
        this.props.onChange(content);
    }

    getAudioUrl(audio) {
        var accessToken = UserService.getUser().access_token;
        if (audio !== "https://pocs.digitalpages.com.br/rdpcomposer/media/audio-1/audio-1.mp3") {
            audio += "&access_token=" + accessToken;
        };
        return audio;
    }

    renderAudiobook() {
        return (
            <StyledThemeProvider>
                <GlobalStyles />
                <UserProvider>

                    <PreferencesProvider>
                        <BookProvider book={this.props.book}>
                            <AudioProvider>
                                <Audiobook.AudioContainer>
                                    <Audiobook.AudioHeader />
                                    <Audiobook.AudioPlayer />
                                </Audiobook.AudioContainer>
                                <ChapterList />
                            </AudioProvider>
                        </BookProvider>
                    {/* <div>
                        teste
                    </div> */}
                    </PreferencesProvider>
                </UserProvider>
                <Mode />
            </StyledThemeProvider>
        )
    }

    render() {
        let { headerActionsTemplate, footerActionsTemplate, content } = this.props;
        // var audioStyle = {
        //   background: content.background_color,
        //   paddingTop: content.padding_top + "px",
        //   paddingBottom: content.padding_bottom + "px"
        // }

        return (
            <div className='audiobook-preview'>
                {headerActionsTemplate}
                {this.renderAudiobook()}
                {footerActionsTemplate}
            </div>)
    }
}
